import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const BannerWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  z-index: 1000;
  display: ${props => props.show ? 'block' : 'none'};
  border-top: 1px solid #eee;
`;

const BannerContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const Text = styled.p`
  margin: 0;
  font-size: 14px;
  color: #333;
  flex: 1;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Button = styled.button`
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &.accept {
    background-color: #14464F;
    color: white;
    border: none;
    
    &:hover {
      background-color: #254F51;
    }
  }
  
  &.manage {
    background-color: transparent;
    color: #14464F;
    border: 1px solid #14464F;
    
    &:hover {
      background-color: #f5f5f5;
    }
  }
`;

const PolicyLink = styled(Link)`
  color: #14464F;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`;

const CookieBanner = () => {
  const [show, setShow] = useState(false);
  const { language } = useLanguage();
  
  useEffect(() => {
    // Check if user has already accepted cookies
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (!cookiesAccepted) {
      setShow(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setShow(false);
  };

  const text = {
    en: {
      message: 'We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.',
      accept: 'Accept All',
      manage: 'Manage Preferences',
      policy: 'Cookie Policy'
    },
    es: {
      message: 'Utilizamos cookies para mejorar tu experiencia. Al continuar visitando este sitio, aceptas nuestro uso de cookies.',
      accept: 'Aceptar Todo',
      manage: 'Administrar Preferencias',
      policy: 'Política de Cookies'
    }
  };

  const t = text[language];

  return (
    <BannerWrapper show={show}>
      <BannerContent>
        <Text>
          {t.message}{' '}
          <PolicyLink to="/legal/cookies">
            {t.policy}
          </PolicyLink>
        </Text>
        <ButtonGroup>
          <Button className="accept" onClick={handleAccept}>
            {t.accept}
          </Button>
          <Button className="manage" onClick={() => window.location.href = '/legal/cookies'}>
            {t.manage}
          </Button>
        </ButtonGroup>
      </BannerContent>
    </BannerWrapper>
  );
};

export default CookieBanner; 